export default "__VITE_ASSET__1hCA4rCJ__"